import { render, staticRenderFns } from "./IndustrialPropertyForms.vue?vue&type=template&id=0c0a974c"
import script from "./IndustrialPropertyForms.vue?vue&type=script&lang=js"
export * from "./IndustrialPropertyForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports